<div class="modal-header d-flex align-items-center">
  <div class="modal-title">
    {{ title }}
  </div>
</div>
